/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Peak_Power_One_LinerInputs */

const en_exp_peak_power_one_liner = /** @type {(inputs: Exp_Peak_Power_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your best average power over 5 s, 1, 5, 20 and 60 minutes of this ride — your power curve in five bars.`)
};

const de_exp_peak_power_one_liner = /** @type {(inputs: Exp_Peak_Power_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine beste mittlere Leistung über 5 s, 1, 5, 20 und 60 Minuten dieser Fahrt — deine Leistungskurve in fünf Balken.`)
};

/**
* | output |
* | --- |
* | "Your best average power over 5 s, 1, 5, 20 and 60 minutes of this ride — your power curve in five bars." |
*
* @param {Exp_Peak_Power_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_peak_power_one_liner = /** @type {((inputs?: Exp_Peak_Power_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Peak_Power_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_peak_power_one_liner(inputs)
	return de_exp_peak_power_one_liner(inputs)
});